// react
import React, { useEffect, useState } from 'react';

// third-party
import { TextBox } from 'devextreme-react';


// application
import Indicator from './Indicator';
import http from '../../utils/http';
import { HubConnectionBuilder } from "@microsoft/signalr";
import BillCxCNotify from '../bill/BillCxCNotify';
import { valueHasAny } from '../../utils/common';

function IndicatorCart(props) {

    const [connection, setConnection] = useState(null);

    const [notis, setNotis] = useState([]);

    const getNotifications = params => http('about/get-notifations').asGet(params).then(r => setNotis(r));

    useEffect(() => {

        const connect = new HubConnectionBuilder()
            .withUrl("/api/billHubs")
            .withAutomaticReconnect()
            .build();

        setConnection(connect);


    }, [0]);

    useEffect(() => {

        getNotifications();

        if (connection) {
            connection.start()
                .then(() => {
                    connection.on("Receive", message => {

                        getNotifications();

                    });
                })
                .catch((error) => console.log(error));
        }
    }, [connection]);

    const filterBills = value => {

        let params = {}

        const hasValue = valueHasAny(value);
        const isNumber = isFinite(value);

        if (hasValue && isNumber)
            params.id = value;        
        else if(hasValue && !isNumber)
            params.name = value;

        getNotifications(params);

    }

    const onSave = e => filterBills('');

    //     <div className="dropcart__buttons">
    //     <Link className="btn btn-secondary" to="/shop/cart">View Cart</Link>
    //     <Link className="btn btn-primary" to="/shop/checkout">Checkout</Link>
    // </div>


    const dropdown = 
        <div className="dropcart">
            <div className="dropcart__empty">
                <label className="bill-notify-title">Notificaciones</label>
                <TextBox
                    showClearButton={true}
                    placeholder="Buscar factura o cliente"
                    className="m-5"
                    stylingMode="filled"
                    onValueChange={filterBills}
                />
                {
                    notis.length == 0 ? 
                        <div className="dropcart__empty">
                            No se encontraron facturas!
                        </div> 
                    : 
                        <ul className="dropcart__product-options">
                            {notis.map((bill, index) => (
                                <li key={index}>
                                    <BillCxCNotify bill={bill} onSave={onSave} />
                                </li>
                            ))}
                        </ul>
                }

            </div>
        </div>;


    return (
        <Indicator url="/shop/cart" dropdown={dropdown} value={notis.length} icon={<span className="far fa-bell"></span>} />
    );
}

export default IndicatorCart;
